/**
 * Listicle — Product card (sections/pb-listicle-product.liquid) and Product grid cards
 * (sections/pb-listicle-product-grid.liquid; each card is its own [data-pb-listicle-product] root).
 * Switches photos, caption, price and the add-to-cart variant when another option pill is picked,
 * and drives the per-option photo carousel (arrows, dots, arrow keys; swiping is native scroll-snap).
 * Adding to cart itself is the /cart/add form, which pb-cart.js (autoHookAddToCart) routes to PBCart.
 * Delegated on document, so it keeps working after the theme editor re-renders the section.
 */
(function () {
  if (window.__pbListicleProductBooted) return;
  window.__pbListicleProductBooted = true;

  /** @param {HTMLElement} root @param {string} index */
  function selectOption(root, index) {
    root.querySelectorAll('[data-pb-option-index]').forEach(function (el) {
      el.hidden = el.getAttribute('data-pb-option-index') !== index;
      if (!el.hidden && el.matches('[data-pb-carousel]')) updateCarousel(/** @type {HTMLElement} */ (el));
    });

    var data = root.querySelector('[data-pb-option-data][data-index="' + index + '"]');
    var input = root.querySelector('[data-pb-option-variant]');
    var button = root.querySelector('[data-pb-option-atc], .pb-listicle-product__atc');
    if (!data || !input || !button) return;

    input.value = data.getAttribute('data-variant-id') || '';

    var available = data.getAttribute('data-available') === 'true';
    button.disabled = !available;
    button.textContent = available
      ? button.getAttribute('data-label') || ''
      : button.getAttribute('data-sold-out-label') || '';
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!(target instanceof HTMLInputElement) || !target.matches('[data-pb-option-input]')) return;

    var root = target.closest('[data-pb-listicle-product]');
    if (root instanceof HTMLElement) selectOption(root, target.value);
  });

  /* ---------- Photo carousel (one per option) ---------- */

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /** @param {HTMLElement} track */
  function currentSlide(track) {
    var width = track.clientWidth || 1;
    return Math.round(track.scrollLeft / width);
  }

  /** @param {HTMLElement} carousel */
  function updateCarousel(carousel) {
    var track = carousel.querySelector('[data-pb-carousel-track]');
    if (!(track instanceof HTMLElement)) return;

    var count = track.children.length;
    var index = Math.min(Math.max(currentSlide(track), 0), count - 1);

    carousel.querySelectorAll('[data-pb-carousel-dot]').forEach(function (dot) {
      if (Number(dot.getAttribute('data-pb-carousel-dot')) === index) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });

    var prev = carousel.querySelector('[data-pb-carousel-prev]');
    var next = carousel.querySelector('[data-pb-carousel-next]');
    if (prev instanceof HTMLButtonElement) prev.disabled = index <= 0;
    if (next instanceof HTMLButtonElement) next.disabled = index >= count - 1;
  }

  /** @param {HTMLElement} carousel @param {number} index */
  function goToSlide(carousel, index) {
    var track = carousel.querySelector('[data-pb-carousel-track]');
    if (!(track instanceof HTMLElement)) return;

    var count = track.children.length;
    var target = Math.min(Math.max(index, 0), count - 1);
    track.scrollTo({ left: target * track.clientWidth, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var control = target.closest('[data-pb-carousel-prev], [data-pb-carousel-next], [data-pb-carousel-dot]');
    if (!control) return;

    var carousel = control.closest('[data-pb-carousel]');
    var track = carousel && carousel.querySelector('[data-pb-carousel-track]');
    if (!(carousel instanceof HTMLElement) || !(track instanceof HTMLElement)) return;

    var index = currentSlide(track);
    if (control.hasAttribute('data-pb-carousel-prev')) index -= 1;
    else if (control.hasAttribute('data-pb-carousel-next')) index += 1;
    else index = Number(control.getAttribute('data-pb-carousel-dot')) || 0;

    goToSlide(carousel, index);
  });

  // Arrow keys on the focused track.
  document.addEventListener('keydown', function (event) {
    var target = event.target;
    if (!(target instanceof HTMLElement) || !target.matches('[data-pb-carousel-track]')) return;
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

    var carousel = target.closest('[data-pb-carousel]');
    if (!(carousel instanceof HTMLElement)) return;

    event.preventDefault();
    goToSlide(carousel, currentSlide(target) + (event.key === 'ArrowRight' ? 1 : -1));
  });

  // Scroll events do not bubble; capture them to keep dots and arrows in sync with swipes.
  var scrollFrame = 0;
  document.addEventListener(
    'scroll',
    function (event) {
      var target = event.target;
      if (!(target instanceof HTMLElement) || !target.matches('[data-pb-carousel-track]')) return;

      var carousel = target.closest('[data-pb-carousel]');
      if (!(carousel instanceof HTMLElement)) return;

      cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(function () {
        updateCarousel(/** @type {HTMLElement} */ (carousel));
      });
    },
    true,
  );

  function syncAll() {
    document.querySelectorAll('[data-pb-listicle-product]').forEach(function (root) {
      var checked = root.querySelector('[data-pb-option-input]:checked');
      selectOption(/** @type {HTMLElement} */ (root), checked ? checked.value : '0');
    });
    document.querySelectorAll('[data-pb-carousel]').forEach(function (carousel) {
      updateCarousel(/** @type {HTMLElement} */ (carousel));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }
  document.addEventListener('shopify:section:load', syncAll);
})();
